import type { ScreenContext } from './types.ts';
import { setButtonLoading } from '@/components/continue-button.ts';
import { updateSessionChoice } from '@/api/operations.ts';

export function renderShiftChoice(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const startedAt = performance.now();

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Choose your path</p>
        <h2 class="text-2xl font-semibold text-gray-900">Switch to calmer tracks or keep the tense energy?</h2>
        <p class="text-gray-700 mt-1">The next two clips will match this choice.</p>
      </div>
      <div class="grid grid-cols-1 gap-3" id="choices"></div>
      <div id="action-slot" class="hidden"></div>
    </div>
  `;

  const choices = container.querySelector('#choices') as HTMLElement;

  const shiftBtn = document.createElement('button');
  shiftBtn.className =
    'btn-primary w-full py-4 flex items-center justify-center gap-2 text-lg';
  shiftBtn.textContent = 'Shift my mood';

  const stayBtn = document.createElement('button');
  stayBtn.className =
    'btn-primary w-full py-4 flex items-center justify-center gap-2 text-lg';
  stayBtn.textContent = 'Stay with it';

  choices.appendChild(shiftBtn);
  choices.appendChild(stayBtn);

  const handleChoice = async (choice: 'shift' | 'stay', btn: HTMLButtonElement) => {
    setButtonLoading(btn, true, btn.textContent || 'Continue', 'Saving...');
    dispatch({ type: 'SET_SHIFT_CHOICE', payload: choice });

    if (state.sessionId) {
      try {
        const durationMs = Math.round(performance.now() - startedAt);
        await updateSessionChoice(state.sessionId, choice, durationMs);
      } catch (error) {
        console.error('Failed to update shift choice', error);
      }
    }

    dispatch({ type: 'NEXT_PHASE' });
    setButtonLoading(btn, false, btn.textContent || 'Continue');
  };

  shiftBtn.addEventListener('click', () => handleChoice('shift', shiftBtn));
  stayBtn.addEventListener('click', () => handleChoice('stay', stayBtn));
}
